import type { Mutation } from '@ab-core/graphql/dist';
import { useMutation } from '@apollo/client';
import { useCallback, useEffect, useState } from 'react';
import { getErrorLoggerFunction } from '../utils';
import { SAVE_FAIR_CODE } from './gql/saveFairCode';

type MutationDataType = Pick<Mutation, 'saveFairCode'>;
type ResponseDataType = MutationDataType | undefined;

const onError = getErrorLoggerFunction('saveFairCode');

export const useSaveFairCode = () => {
    const [response, setResponse] = useState<ResponseDataType>(undefined);

    const [saveFairCode, { loading, error, data }] = useMutation<MutationDataType>(SAVE_FAIR_CODE, {
        variables: { code: 'markus' },
        onError
    });

    const outgoingSaveFairCode = useCallback(
        (code: string) => {
            saveFairCode({ variables: { code } });
        },
        [saveFairCode]
    );

    useEffect(() => {
        if (data) {
            setResponse(data);
        }
    }, [data]);

    return {
        success: !!data,
        error: !!error,
        saveFairCode: outgoingSaveFairCode,
        loading,
        response
    };
};
